import React from 'react';
import Switch from '@material-ui/core/Switch';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({ data, onToggle }) => {
    const rows = [
        {
            label: 'Show/Hide',
            value: <Switch
                checked={data.value}
                onChange={onToggle}
                color="primary"
                size="small"
                inputProps={{ 'aria-label': 'primary checkbox' }}
            />,
            inHeader: true,
            hideLabel: true,
        },
        ...(data.help ? [{ label: 'Description', value: data.help, fullWidth: true }] : []),
        ...(data.example ? [{ label: 'Eg', value: data.example, fullWidth: true }] : []),
    ];

    return (
        <PPMobileCardView
            title={data.label}
            rows={rows}
        />
    );
};

export default Mobile;
